import { AssessmentReportUI } from 'features'

const AssessmentReport = () => {
  return (
    <div>
      <AssessmentReportUI/>
    </div>
  )
}

export { AssessmentReport }
